import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { WorkflowApi } from "../../api/workflows/service.ts";
import { makeWorkflowApi } from "../../api/workflows/live.ts";
import { WorkflowBrowserIo } from "./browser-service.ts";
import { WorkflowChangeIoLive } from "./changes-live.ts";
export const WorkflowBrowserIoLive = Layer.succeed(WorkflowBrowserIo, {
  prompt: Effect.fn("Frontend.Workflow.prompt")((message: string, initial?: string) => Effect.try({ try: () => window.prompt(message, initial), catch: () => resourceUnavailable() })),
  alert: Effect.fn("Frontend.Workflow.alert")((message: string) => Effect.try({ try: () => window.alert(message), catch: () => resourceUnavailable() })),
  copy: Effect.fn("Frontend.Workflow.copy")((text: string) => Effect.tryPromise({ try: () => navigator.clipboard.writeText(text), catch: () => resourceUnavailable() }))
});
const WorkflowBrowserApiLive = Layer.effect(WorkflowApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeWorkflowApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const WorkflowBrowserPortsLive = Layer.mergeAll(WorkflowBrowserApiLive, WorkflowBrowserIoLive, WorkflowChangeIoLive);
